import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.name || !formData.email || !formData.message) {
      setStatus({
        loading: false,
        success: false,
        error: "Please fill in all required fields",
      });
      return;
    }

    setStatus({ loading: true, success: false, error: null });

    try {
      // Create FormData object for multipart/form-data
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("subject", formData.subject);
      data.append("message", formData.message);

      // Send to PHP endpoint
      const response = await fetch("send-email.php", {
        method: "POST",
        body: data,
      });

      const result = await response.json();

      if (result.success) {
        setStatus({
          loading: false,
          success: true,
          error: null,
        });
        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
        console.log("Email sent successfully!");
      } else {
        setStatus({
          loading: false,
          success: false,
          error: result.message || "Failed to send email",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus({
        loading: false,
        success: false,
        error: "Error sending email. Please try again later.",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {status.success && (
        <div className="alert alert-success" role="alert">
          Thank you! Your message has been sent successfully.
        </div>
      )}
      {status.error && (
        <div className="alert alert-danger" role="alert">
          {status.error}
        </div>
      )}

      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="phone"
              className="form-control"
              placeholder="Phone number"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <input
              type="text"
              name="subject"
              className="form-control"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div className="form-group">
        <textarea
          name="message"
          rows="10"
          className="form-control"
          placeholder="Write message"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
      </div>
      <button type="submit" className="btn" disabled={status.loading}>
        {status.loading ? "Sending..." : "Send a message"}
      </button>
    </form>
  );
};

export default ContactForm;
